import { render, staticRenderFns } from "./obs-question-message.vue?vue&type=template&id=36cc6c60&"
import script from "./obs-question-message.vue?vue&type=script&lang=js&"
export * from "./obs-question-message.vue?vue&type=script&lang=js&"
import style0 from "./obs-question-message.vue?vue&type=style&index=0&module=true&lang=less&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports